<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      :class="this.$store.state.isRTL ? '' : ' me-sm-6'"
    >
      <li class="text-sm breadcrumb-item" :class="textWhite">
        <a
          v-if="this.$store.state.isRTL"
          :class="textWhite"
          class="opacity-5 ps-2"
          href="#"
          >لوحات القيادة</a
        >
        <a v-else :class="textWhite" class="opacity-8" href="#">Pages</a>
      </li>
      <li
        class="text-sm breadcrumb-item active"
        :class="textWhite ? 'text-white' : 'text-dark'"
        aria-current="page"
      >
        {{ currentPage }}
      </li>
    </ol>
    <h2>Client: {{ clientName }} {{ clientLastName }}</h2>
    <div>
      <button
        v-if="showTimeOutButton"
        class="btn mt-3 btn-warning"
        @click="timeOutEntry"
      >
        Time Out
      </button>
      <button
        v-if="!showTimeOutButton"
        class="btn mt-3"
        :class="timeOutButtonClass"
        @click="toggleServiceCodeInput"
      >
        {{ timeOutButtonText }}
      </button>
      <div v-if="showServiceCodeInput" class="mt-3">
        <label for="">Service Code</label>
        <select
          v-model="serviceCode"
          class="form-control d-inline-block w-auto"
        >
          <option disabled value="">
            {{
              serviceCode.length
                ? "---Select Service Code---"
                : "No service code available"
            }}
          </option>
          <option v-for="code in serviceCodes" :key="code" :value="code">
            {{ code }}
          </option>
        </select>
        <button class="btn btn-success ml-2 mt-3" @click="submitServiceCode">
          Submit
        </button>
      </div>
    </div>
    <div v-if="timeInHours !== null">
      <p>Current Running Time: {{ timeInHours }} hours</p>
    </div>
  </nav>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment-timezone";
import { isPublicAuthPath } from "@/utils/publicAuthRoutes";

export default {
  name: "breadcrumbs",
  props: {
    currentPage: {
      required: true,
    },
    textWhite: {
      type: String,
    },
  },
  data() {
    return {
      showServiceCodeInput: false,
      serviceCode: [],
      timeInHours: null,
      timesheetID: null,
      showTimeOutButton: false,
      startDate: null,
      startTime: null,
      timeInterval: null,
      serverTime: null,
      isMobile: false,
      clientName: null,
      clientLastName: null,
      status: {
        personalInformation: false,
        paymentDetails: false,
        serviceDetails: false,
        eligibility: false,
        signature: false,
      },
    };
  },
  computed: {
    timeOutButtonClass() {
      return this.showServiceCodeInput ? "btn-danger" : "btn-info";
    },
    timeOutButtonText() {
      return this.showServiceCodeInput ? "Cancel" : "Time In";
    },
  },
  async mounted() {
    if (isPublicAuthPath(this.$route.path)) return;
    if (!localStorage.getItem("token")) return;

    await this.checkTimeInEntry();
    this.startTimeInterval(); // Start the time interval
    this.detectMobile();
    this.fetchClients();
    this.fetch_employee_data();
  },
  beforeUnmount() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval); // Clean up interval when component is destroyed
    }
  },
  methods: {
    fetchClients() {
      const token = localStorage.getItem("token");
      if (!token) return;
      if (isPublicAuthPath(this.$route.path)) return;

      fetch(`${process.env.VUE_APP_BACKEND_DOMAIN}/api/client_fetch_limit_1`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then(async (response) => {
          if (!response.ok) return;
          const data = await response.json();
          const clients = (data?.clients || []).filter((entry) => Number(entry.status) === 1 && entry.client);
          const selectedId = localStorage.getItem("selectedClientId");
          const client = (clients.find((entry) => String(entry.client.id) === selectedId) || clients[0])?.client;
          if (!client) return;
          localStorage.setItem("selectedClientId", client.id);
          localStorage.setItem("clientName", client.first_name);
          localStorage.setItem("clientLastName", client.last_name);
          this.clientName = client.first_name;
          this.clientLastName = client.last_name;
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
        });
    },
    detectMobile() {
      // Detect if the device is mobile (screen width less than 768px)
      this.isMobile = window.innerWidth < 768;
    },
    async checkTimeInEntry() {
      const token = localStorage.getItem("token");
      if (!token) return;
      if (isPublicAuthPath(this.$route.path)) return;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/check_time_in`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            validateStatus: (status) => status < 500,
          }
        );

        if (response.status !== 200) return;

        if (response.data?.timesheet) {
          this.showServiceCodeInput = false;
          this.showTimeOutButton = true;
          this.timesheetID = response.data.timesheet.id;
          const { start_date, start_time } = response.data.timesheet;
          this.startDate = start_date;
          this.startTime = start_time;
          const serverTimeData = response.data.timesheet.server_time;
          if (serverTimeData) {
            this.serverTime = new Date(serverTimeData).getTime(); // Store server time in milliseconds
            this.calculateTimeInHours(start_date, start_time);
          } else {
            this.calculateTimeInHours(start_date, start_time);
          }
        } else {
          this.showTimeOutButton = false;
          this.showServiceCodeInput = false;
          this.timeInHours = null;
        }
      } catch (error) {
        console.error("Error checking time in entry:", error);
      }
    },

    // New function to calculate hours using local time and server offset

    calculateTimeInHours(startDate, startTime) {
      if (!startDate || !startTime || !this.serverTime) return;

      // Combine startDate and startTime into a timestamp string
      const startTimeStamp = new Date(`${startDate}T${startTime}`).getTime();

      // Get current time in UTC
      const currentTimeUtc = moment.utc();

      // Convert the user's server time to the specific US timezone (EST for example)
      const usTime = currentTimeUtc.tz("America/New_York"); // For EST, you can use 'America/New_York'
      const usTimeMillis = usTime.valueOf(); // Convert the time to milliseconds

      // Calculate time difference between user time and server time
      const timeDiff =
        usTimeMillis - this.serverTime + (startTimeStamp - this.serverTime);

      // Calculate hours, minutes, and seconds
      const hours = Math.floor(timeDiff / (1000 * 60 * 60)); // Hours
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)); // Minutes
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000); // Seconds

      // Update timeInHours
      this.timeInHours = `${this.padTime(hours)}:${this.padTime(
        minutes
      )}:${this.padTime(seconds)}`;
    },

    padTime(time) {
      return time < 10 ? `0${time}` : time;
    },
    async fetch_employee_data() {
      const token = localStorage.getItem("token");
      if (!token) return;
      if (isPublicAuthPath(this.$route.path)) return;

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/fetch-employee-data`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.success) {
          let codesString = res.data.data.service_code || "";
          codesString = codesString.replace(/["[\]]/g, "");
          this.serviceCodes = codesString.split(",").map((code) => code.trim());
          this.serviceCode = this.serviceCodes.length
            ? this.serviceCodes[0]
            : null;
        }
      } catch (err) {
        console.error("Failed to fetch employee data", err);
        Swal.fire("Error", "Could not fetch employee data", "error");
      }
    },
    async fetch_checklist() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/enrollment-checklist`,
          {
            params: { client_id: localStorage.getItem("selectedClientId") },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (res.data.success) {
          this.status.personalInformation = res.data.personal_information;
          this.status.paymentDetails = res.data.payment_details;
          this.status.serviceDetails = res.data.service_details;
          this.status.eligibility = res.data.eligibility;
          this.status.signature = res.data.signature;
          const failed = [];
          if (!this.status.personalInformation)
            failed.push("Personal Information not completed");
          if (!this.status.paymentDetails)
            failed.push("Payment Details missing");
          if (!this.status.serviceDetails)
            failed.push("Service Details not set");
          if (!this.status.eligibility)
            failed.push("Eligibility requirements not met");
          if (!this.status.signature) failed.push("Signature not uploaded");

          if (failed.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Checklist Incomplete",
              html: `<ul style="text-align:left;">${failed
                .map((msg) => `<li>${msg}</li>`)
                .join("")}</ul>`,
            });
            return false;
          }
          return true;
        }
      } catch (err) {
        console.error("Failed to fetch status", err);
        return false;
      }
    },

    startTimeInterval() {
      this.timeInterval = setInterval(() => {
        if (this.showTimeOutButton && this.startDate && this.startTime) {
          this.calculateTimeInHours(this.startDate, this.startTime); // Update time every second
        }
      }, 1000); // Update every second (1000ms)
    },

    async toggleServiceCodeInput() {
      let checklist = await this.fetch_checklist(); // wait for the result
      if (!checklist) return; // will now correctly block if false
      this.showServiceCodeInput = !this.showServiceCodeInput;
    },

    async timeOutEntry() {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("timesheet_Id", this.timesheetID);
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/time_out`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response);
        this.showTimeOutButton = false;
        location.reload();
        this.checkTimeInEntry();
        this.showServiceCodeInput = true;
      } catch (error) {
        console.error("Error submitting service code:", error);
      }
    },

    async submitServiceCode() {
      const client_id = localStorage.getItem("selectedClientId");
      if (!client_id) {
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `Please Select a Client to clock in`,
        });
      }
      if (!this.serviceCode) {
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `Please add your service code in the enrollment menu.`,
        });
      }
      console.log(`Service Code Submitted: ${this.serviceCode}`);
      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("service_code", this.serviceCode);
      formData.append("client_id", client_id);
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/time_in`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response);
        this.checkTimeInEntry();
        this.showServiceCodeInput = true;
      } catch (error) {
        if (error.response && error.response.status === 400) {
          console.error("Validation errors:", error.response.data.error);
          const errorMessage = error.response.data.error.client_id[0];
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${errorMessage}`,
          });
        } else {
          console.error("Error submitting service code:", error);
        }
      }
    },
  },
};
</script>

<style scoped>
.mt-3 {
  margin-top: 1rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
</style>
